module.exports = "<section id=\"legal\" class=\"container-fluid\">\n\n  <h1> LEGAL </h1>\n\n  <div class=\"row\">\n    <div class=\"col-sm-offset-3 col-sm-6\">\n      <ui-view></ui-view>\n    </div>\n  </div>\n\n</section>\n\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/legal/legal.html
// module id = 820
// module chunks = 1